import React, { useState } from "react";
import "./CardInfo.css";

export default function CardInfo({ meal, onClose }) {
  const [activeTab, setActiveTab] = useState("ingredients");
  const [isClosing, setIsClosing] = useState(false);

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(onClose, 250);
  };

  return (
    <div
      className={`ci-overlay${isClosing ? " closing" : ""}`}
      onClick={handleClose}
    >
      <div
        className={`ci-panel${isClosing ? " closing" : ""}`}
        onClick={(e) => e.stopPropagation()}
      >
        <button className="ci-close" onClick={handleClose} aria-label="Fermer">
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
            aria-hidden="true"
          >
            <line x1="1" y1="1" x2="13" y2="13" />
            <line x1="13" y1="1" x2="1" y2="13" />
          </svg>
        </button>

        <div className="ci-image">
          <img src={meal.image} alt={meal.title} />
        </div>

        <div className="ci-infos">
          {/* Title card */}
          <div className="ci-card">
            <h2 className="ci-title">{meal.title}</h2>
            {meal.tags && meal.tags.length > 0 && (
              <div className="ci-tags">
                {meal.tags.map((tag, i) => (
                  <span key={i} className="ci-tag">
                    {tag.label}
                  </span>
                ))}
              </div>
            )}
            {meal.description && (
              <p className="ci-description">{meal.description}</p>
            )}
          </div>

          {/* Facts card */}
          <div className="ci-card">
            <div className="ci-tabs">
              <button
                className={`ci-tab${activeTab === "ingredients" ? " ci-tab--active" : ""}`}
                onClick={() => setActiveTab("ingredients")}
              >
                Ingrédients
              </button>
              <button
                className={`ci-tab${activeTab === "allergens" ? " ci-tab--active" : ""}`}
                onClick={() => setActiveTab("allergens")}
              >
                Allergènes
              </button>
              <button
                className={`ci-tab${activeTab === "nutrition" ? " ci-tab--active" : ""}`}
                onClick={() => setActiveTab("nutrition")}
              >
                Valeurs nutritives
              </button>
            </div>

            {activeTab === "ingredients" && (
              <p className="ci-ingredients">
                {meal.ingredients || "Information non disponible."}
              </p>
            )}

            {activeTab === "allergens" && (
              <div className="ci-allergens">
                <div className="ci-allergen-group">
                  <p className="ci-allergen-label">Contient</p>
                  <p className="ci-allergen-value">
                    {meal.allergens?.contains || "Aucun allergène déclaré."}
                  </p>
                </div>
                {meal.allergens?.mayContain && (
                  <div className="ci-allergen-group">
                    <p className="ci-allergen-label">Peut contenir</p>
                    <p className="ci-allergen-value">
                      {meal.allergens.mayContain}
                    </p>
                  </div>
                )}
              </div>
            )}

            {activeTab === "nutrition" && (
              <div className="ci-nutrition">
                {meal.nutrition?.totalWeight && (
                  <p className="ci-nutrition-weight">
                    Poids total du repas : {meal.nutrition.totalWeight}
                  </p>
                )}
                <div className="ci-nutrition-table">
                  <div className="ci-nutrition-header">
                    <p className="ci-nutrition-title">Valeur nutritive</p>
                    <p className="ci-nutrition-serving">
                      {meal.nutrition?.serving}
                    </p>
                  </div>
                  <div className="ci-nutrition-divider" />
                  <div className="ci-nutrition-row ci-nutrition-calories">
                    <span className="ci-nutrition-calories-label">
                      Calories {meal.nutrition?.calories}
                    </span>
                    <span className="ci-nutrition-dv">
                      % valeur quotidienne*
                    </span>
                  </div>
                  {meal.nutrition?.rows?.map((row, i) => (
                    <React.Fragment key={i}>
                      <div className="ci-nutrition-divider" />
                      <div className="ci-nutrition-row">
                        <span className={row.bold ? "ci-nutrition-bold" : ""}>
                          {row.label}
                        </span>
                        {row.dv && <span>{row.dv}</span>}
                      </div>
                      {row.subRows?.map((sub, j) => (
                        <div
                          className="ci-nutrition-row ci-nutrition-sub"
                          key={j}
                        >
                          <span>{sub.label}</span>
                          {sub.dv && <span>{sub.dv}</span>}
                        </div>
                      ))}
                    </React.Fragment>
                  ))}
                  <div className="ci-nutrition-divider ci-nutrition-divider--thick" />
                  {meal.nutrition?.footer && (
                    <p className="ci-nutrition-footer">
                      {meal.nutrition.footer}
                    </p>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
